import { createFileRoute, Outlet } from "@tanstack/react-router"
import { getTypedQueryData } from "../../../typed-client/get-typed-query-data"

export const Route = createFileRoute("/app/contacts/$id")({
  component: Outlet,
  beforeLoad(context) {
    const person =
      context.context.queryClient &&
      getTypedQueryData(context.context.queryClient, "/api/Person/GetPerson", {
        personId: parseInt(context.params.id),
      })

    return { getTitle: () => [person?.firstName, person?.lastName].join(" ") }
  },
})
